export default function sanityFile(reference, queryData) {
    return queryData?.allSanityFileAsset?.nodes.find(node => node?.assetId === reference.substring(reference.indexOf('-') + 1, reference.lastIndexOf('-')))
}